import styled from 'styled-components'
import { breakpoints } from '../../../utils'

export const StyledApp = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  box-sizing: border-box;
  overflow: hidden;

  /* Allows you to scroll below the viewport; default value is visible */
  section {
    margin: 0 auto;
  }
  @media (max-width: ${breakpoints[4]}px) {
    padding-top: ${({ styles, isNavMenuPresent }) => styles && (isNavMenuPresent ? styles.mobilePaddingTop : styles.mobileNoNavPaddingTop)}px;
  }
  @media (min-width: ${breakpoints[4] + 1}px) {
    padding-top:  ${({ styles, isNavMenuPresent }) => styles && (isNavMenuPresent ? styles.desktopPaddingTop : styles.desktopNoNavPaddingTop)}px;
  }
`
